import { render, staticRenderFns } from "./acces-prestations.vue?vue&type=template&id=4ee39442&scoped=true"
import script from "./acces-prestations.vue?vue&type=script&lang=js"
export * from "./acces-prestations.vue?vue&type=script&lang=js"
import style0 from "./acces-prestations.vue?vue&type=style&index=0&id=4ee39442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee39442",
  null
  
)

export default component.exports